<template>
  <div class="site-page">
    <!-- FLOAT BUTTONS -->
    <div class="float-actions">
      <button class="float-btn insta" @click="openInsta" aria-label="Instagram">
        <v-icon size="23">mdi-instagram</v-icon>
      </button>
      <button class="float-btn whats" @click="enviarWhatsapp" aria-label="WhatsApp">
        <v-icon size="23">mdi-whatsapp</v-icon>
      </button>
    </div>

    <!-- NAVBAR -->
    <header class="topbar">
      <div class="topbar-inner">
        <v-sheet class="logo-box" color="transparent" @click="scrollTo('hero')">
          <v-img alt="Logo Leh Fátima Catalisadores" :src="require('@/assets/img/logo.png')" contain />
        </v-sheet>

        <nav class="nav-links">
          <button @click="scrollTo('processo')">Processo</button>
          <button @click="scrollTo('galeria')">Modelos</button>
          <button @click="scrollTo('videos')">Vídeos</button>
          <button @click="scrollTo('faq')">Dúvidas</button>
        </nav>

        <v-btn rounded="pill" class="nav-cta text-none" elevation="0" @click="enviarWhatsapp">
          Cotar peça
          <v-icon end>mdi-arrow-right</v-icon>
        </v-btn>

        <button class="menu-toggle" @click="menuOpen = !menuOpen" aria-label="Abrir menu">
          <v-icon size="31">{{ menuOpen ? 'mdi-close' : 'mdi-menu' }}</v-icon>
        </button>
      </div>

      <v-expand-transition>
        <div v-if="menuOpen" class="mobile-panel">
          <button @click="goToMobile('processo')">Processo</button>
          <button @click="goToMobile('galeria')">Modelos</button>
          <button @click="goToMobile('videos')">Vídeos</button>
          <button @click="goToMobile('faq')">Dúvidas</button>
          <button @click="goToMobile('orcamento')">Contato</button>
        </div>
      </v-expand-transition>
    </header>

    <!-- HERO -->
    <section id="hero" class="hero">
      <div class="hero-pattern"></div>

      <div class="container hero-layout">
        <div class="hero-right" data-aos="fade-left" data-aos-duration="900">
          <div class="photo-stack">
            <div class="photo-card main">
              <img :src="imagemBanner" alt="Catalisador automotivo" />
            </div>

            <div class="photo-card small one">
              <img :src="imagens[0].url" :alt="imagens[0].titulo" />
            </div>

            <div class="photo-card small two">
              <img :src="imagens[1].url" :alt="imagens[1].titulo" />
            </div>

            <div class="stamp-card">
              <strong>+100</strong>
              <span>modelos avaliados</span>
            </div>
          </div>
        </div>

        <div class="hero-left" data-aos="fade-right" data-aos-duration="900">
          <span class="tiny-label">Leh Fátima Catalisadores</span>

          <h1>
            Compre e venda catalisadores com
            <mark>avaliação rápida</mark>
          </h1>

          <p>
            Atendimento pelo WhatsApp para cotação, compra, venda e consulta de modelos.
          </p>

          <div class="hero-buttons">
            <v-btn rounded="pill" size="x-large" class="primary-btn text-none" elevation="0" @click="enviarWhatsapp">
              Falar no WhatsApp
              <v-icon end>mdi-whatsapp</v-icon>
            </v-btn>

            <v-btn rounded="pill" size="x-large" class="ghost-btn text-none" elevation="0" @click="scrollTo('galeria')">
              Ver catálogo
            </v-btn>
          </div>
        </div>
      </div>
    </section>

    <!-- FAIXA DE IMAGENS CORRIGIDA -->
    <section class="image-marquee" aria-label="Faixa de catalisadores">
      <div class="marquee-track">
        <div v-for="(item, index) in imagensLoop" :key="index" class="marquee-item">
          <img :src="item.url" :alt="item.titulo" />
        </div>
      </div>
    </section>

    <!-- PAINEL DE SERVIÇOS -->
    <section id="processo" class="section services-section">
      <div class="container">
        <div class="section-title split" data-aos="fade-up">
          <div>
            <span class="tiny-label">Processo simples</span>
            <h2>Envie, avalie e negocie</h2>
          </div>
          <p>Uma jornada direta, com poucos passos e comunicação pelo WhatsApp.</p>
        </div>

        <div class="service-board">
          <article class="service-feature" data-aos="fade-right">
            <img :src="require('@/assets/img/catalisador.png')" alt="Catalisador" />
            <div>
              <span>Compra • Venda • Consulta</span>
              <h3>Cotação por imagem ou dados do veículo</h3>
            </div>
          </article>

          <div class="steps-list">
            <article
                v-for="(item, index) in steps"
                :key="item.title"
                class="step-line"
                data-aos="fade-up"
                :data-aos-delay="80 * index"
            >
              <div class="step-index">{{ index + 1 }}</div>
              <div>
                <v-icon :icon="item.icon" size="28" color="#e11d48" />
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <!-- GALERIA CORRIGIDA -->
    <section id="galeria" class="section catalog-section">
      <div class="container">
        <div class="section-title center" data-aos="fade-up">
          <span class="tiny-label">Catálogo visual</span>
          <h2>Modelos em destaque</h2>
          <p>Uma vitrine limpa, alinhada e sem sobreposição entre os cards.</p>
        </div>

        <div class="catalog-highlight" data-aos="fade-up">
          <div class="highlight-copy">
            <span>Peças selecionadas</span>
            <h3>Consulte o modelo ideal para seu veículo</h3>
            <p>Envie a foto ou o modelo do veículo e receba atendimento direto pelo WhatsApp.</p>

            <v-btn rounded="pill" class="primary-btn text-none mt-5" elevation="0" @click="enviarWhatsapp">
              Consultar agora
              <v-icon end>mdi-whatsapp</v-icon>
            </v-btn>
          </div>

          <div class="highlight-gallery">
            <div v-for="item in imagens.slice(0, 3)" :key="item.titulo" class="highlight-card">
              <img :src="item.url" :alt="item.titulo" />
            </div>
          </div>
        </div>

        <div class="catalog-grid">
          <article
              v-for="(img, i) in imagens"
              :key="img.titulo"
              class="product-card"
              data-aos="fade-up"
              :data-aos-delay="45 * i"
          >
            <div class="product-image">
              <img :src="img.url" :alt="img.titulo" />
            </div>

            <div class="product-info">
              <div>
                <h3>{{ img.titulo }}</h3>
                <p>{{ img.subtitulo }}</p>
              </div>
              <v-icon size="20" color="#e11d48">mdi-arrow-top-right</v-icon>
            </div>
          </article>
        </div>
      </div>
    </section>

    <!-- VÍDEOS E VANTAGENS -->
    <section id="videos" class="section media-section">
      <div class="container media-grid">
        <div class="media-copy" data-aos="fade-right">
          <span class="tiny-label">Vídeos</span>
          <h2>Veja detalhes das peças</h2>
          <p>Vídeos curtos ajudam o cliente a enxergar melhor o estado e o modelo dos catalisadores.</p>

          <div class="benefit-pills">
            <span v-for="item in vantagens" :key="item">
              <v-icon size="18" color="#22c55e">mdi-check-circle</v-icon>
              {{ item }}
            </span>
          </div>
        </div>

        <div class="video-mosaic" data-aos="fade-left">
          <div v-for="(video, i) in videos" :key="i" class="video-box">
            <video controls playsinline>
              <source :src="video" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </section>

    <!-- FAQ -->
    <section id="faq" class="section faq-section">
      <div class="container faq-grid">
        <div class="faq-card-title" data-aos="fade-right">
          <span class="tiny-label">Dúvidas frequentes</span>
          <h2>Perguntas rápidas</h2>
          <p>Informações objetivas para facilitar o contato.</p>
        </div>

        <v-expansion-panels class="custom-faq" variant="accordion" data-aos="fade-left">
          <v-expansion-panel v-for="(item, index) in faq" :key="index" elevation="0">
            <v-expansion-panel-title>{{ item.q }}</v-expansion-panel-title>
            <v-expansion-panel-text>{{ item.a }}</v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </section>

    <!-- CONTATO -->
    <section id="orcamento" class="contact-band">
      <div class="container contact-layout" data-aos="fade-up">
        <div>
          <span class="tiny-label light">Cotação no WhatsApp</span>
          <h2>Envie sua mensagem e solicite uma avaliação</h2>
        </div>

        <div class="contact-box">
          <v-text-field
              v-model="mensagem"
              variant="solo"
              density="comfortable"
              placeholder="Digite sua mensagem..."
              hide-details
              class="input-message"
          />

          <v-btn rounded="pill" size="large" class="light-btn text-none" elevation="0" @click="enviarWhatsapp">
            Enviar
            <v-icon end>mdi-whatsapp</v-icon>
          </v-btn>
        </div>
      </div>
    </section>

    <footer class="footer">
      <div class="container footer-inner">
        <p>© {{ new Date().getFullYear() }} — Leh Fátima Catalisadores</p>
        <p>Compra e venda de catalisadores automotivos</p>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import imagemBanner from '@/assets/img/catalisador-940x425.jpg'

const menuOpen = ref(false)
const mensagem = ref('')
const numeroElenir = '556596294390'

const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const goToMobile = (id) => {
  menuOpen.value = false
  scrollTo(id)
}

const enviarWhatsapp = () => {
  const texto = mensagem.value || 'Olá! Gostaria de solicitar uma cotação de catalisador.'
  const url = `https://wa.me/${numeroElenir}?text=${encodeURIComponent(texto)}`
  window.open(url, '_blank')
}

const openInsta = () => {
  window.open('https://www.instagram.com/lefatimacatalisadores/', '_blank')
}

const steps = [
  {
    icon: 'mdi-message-image-outline',
    title: 'Envie fotos',
    desc: 'Mande imagens da peça ou os dados do veículo.'
  },
  {
    icon: 'mdi-file-search-outline',
    title: 'Receba a análise',
    desc: 'Avaliamos o modelo e retornamos com a orientação.'
  },
  {
    icon: 'mdi-cash-fast',
    title: 'Negocie com segurança',
    desc: 'Fechamento claro, direto e combinado pelo WhatsApp.'
  },
  {
    icon: 'mdi-truck-check-outline',
    title: 'Combine o envio',
    desc: 'Entrega, retirada ou transporte definidos caso a caso.'
  }
]

const imagens = [
  {
    url: require('@/assets/img/cat1.webp'),
    titulo: 'Catalisador Celta 1.0',
    subtitulo: 'Celta 1.0/1.4 de 2005 em diante - GM'
  },
  {
    url: require('@/assets/img/cat2.webp'),
    titulo: 'Catalisador Montana',
    subtitulo: 'Montana 1.0/1.4 a partir de 2015 - GM'
  },
  {
    url: require('@/assets/img/cat3.webp'),
    titulo: 'Catalisador Spin',
    subtitulo: 'Spin 1.0/1.4/1.8 a partir de 2012 - GM'
  },
  {
    url: require('@/assets/img/cat4.png'),
    titulo: 'Catalisador Argo',
    subtitulo: 'Argo 3 cilindros 1.3'
  },
  {
    url: require('@/assets/img/cat5.png'),
    titulo: 'Catalisador S10',
    subtitulo: 'S10 2.4 Flex 2013 a 2018'
  },
  {
    url: require('@/assets/img/cat6.png'),
    titulo: 'Catalisador S-10',
    subtitulo: 'S-10 Cab Dupla 2.4 2008 a 2010'
  },
  {
    url: require('@/assets/img/cat7.png'),
    titulo: 'Catalisador Gol',
    subtitulo: 'Gol 1.0 8V GV 5ª geração'
  },
  {
    url: require('@/assets/img/cat8.png'),
    titulo: 'Coletor HB20',
    subtitulo: 'HB20 1.6 Hatch/Sedan Flex'
  },
  {
    url: require('@/assets/img/cat9.webp'),
    titulo: 'Catalisador Ka',
    subtitulo: 'Ka 3cc 1.5 a partir de 2015 - Ford'
  }
]

const imagensLoop = computed(() => [...imagens, ...imagens, ...imagens])

const videos = [
  require('@/assets/videos/video-catalisador.mp4'),
  require('@/assets/videos/video-catalisador-2.mp4'),
  require('@/assets/videos/video-catalisador-3.mp4'),
  require('@/assets/videos/video-catalisador-4.mp4')
]

const vantagens = [
  'Procedência verificada',
  'Atendimento rápido',
  'Compra e venda',
  'Suporte especializado',
  'Envio combinado',
  'Pagamento facilitado'
]

const faq = [
  {
    q: 'Vocês compram catalisador usado?',
    a: 'Sim. É possível enviar fotos e dados da peça para avaliação.'
  },
  {
    q: 'Também vendem catalisadores?',
    a: 'Sim. Consulte os modelos disponíveis pelo WhatsApp.'
  },
  {
    q: 'Como funciona o envio?',
    a: 'O envio, retirada ou entrega é combinado conforme a negociação.'
  },
  {
    q: 'Quais formas de pagamento aceitam?',
    a: 'Aceitamos PIX, cartão e outras formas combinadas no atendimento.'
  }
]
</script>

<style scoped>
.site-page {
  min-height: 100vh;
  color: #172033;
  background:
      linear-gradient(90deg, rgba(225, 29, 72, 0.03) 1px, transparent 1px),
      linear-gradient(rgba(225, 29, 72, 0.03) 1px, transparent 1px),
      #fbfaf7;
  background-size: 44px 44px;
  overflow-x: hidden;
}

.container {
  width: min(1180px, calc(100% - 32px));
  margin: 0 auto;
}

.float-actions {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 90;
  display: grid;
  gap: 10px;
}

.float-btn {
  width: 54px;
  height: 54px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  color: #fff;
  box-shadow: 0 18px 38px rgba(23, 32, 51, 0.22);
  transition: 0.24s ease;
}

.float-btn:hover {
  transform: translateY(-4px);
}

.float-btn.insta {
  background: linear-gradient(135deg, #db2777, #f97316);
}

.float-btn.whats {
  background: #22c55e;
}

.topbar {
  position: fixed;
  top: 20px;
  left: 50%;
  z-index: 80;
  width: min(1160px, calc(100% - 28px));
  transform: translateX(-50%);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(23, 32, 51, 0.08);
  box-shadow: 0 18px 52px rgba(23, 32, 51, 0.09);
  backdrop-filter: blur(18px);
}

.topbar-inner {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
  padding: 0 16px 0 24px;
}

.logo-box {
  width: 128px;
  cursor: pointer;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 30px;
  font-size: 14px;
  font-weight: 850;
  color: #5b6476;
}

.nav-links button {
  transition: 0.2s ease;
}

.nav-links button:hover {
  color: #e11d48;
}

.nav-cta,
.primary-btn {
  color: #fff !important;
  background: #172033 !important;
}

.ghost-btn {
  color: #172033 !important;
  background: #ffffff !important;
  border: 1px solid rgba(23, 32, 51, 0.12) !important;
}

.menu-toggle {
  display: none;
  color: #172033;
}

.mobile-panel {
  display: none;
  padding: 0 24px 20px;
}

.mobile-panel button {
  display: block;
  width: 100%;
  padding: 13px 0;
  text-align: left;
  color: #172033;
  font-weight: 850;
}

.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 128px 0 86px;
}

.hero-pattern {
  position: absolute;
  inset: 0;
  background:
      radial-gradient(circle at 8% 28%, rgba(225, 29, 72, 0.16), transparent 25rem),
      radial-gradient(circle at 82% 72%, rgba(34, 197, 94, 0.16), transparent 26rem);
  pointer-events: none;
}

.hero-layout {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 0.88fr 1.12fr;
  align-items: center;
  gap: 72px;
}

.tiny-label {
  display: inline-flex;
  width: fit-content;
  padding: 8px 13px;
  border-radius: 999px;
  color: #e11d48;
  background: #fff1f2;
  border: 1px solid rgba(225, 29, 72, 0.12);
  font-size: 11px;
  font-weight: 950;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.tiny-label.light {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.18);
}

.hero-left h1 {
  max-width: 680px;
  margin-top: 22px;
  color: #172033;
  font-size: clamp(44px, 6.4vw, 86px);
  line-height: 0.92;
  font-weight: 980;
  letter-spacing: -0.07em;
}

.hero-left mark {
  display: inline;
  padding: 0 10px 4px;
  color: #fff;
  background: #e11d48;
  border-radius: 18px;
}

.hero-left p {
  max-width: 520px;
  margin-top: 26px;
  color: #667085;
  font-size: 20px;
  line-height: 1.55;
}

.hero-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 34px;
}

.photo-stack {
  position: relative;
  min-height: 610px;
}

.photo-card {
  position: absolute;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(23, 32, 51, 0.08);
  box-shadow: 0 26px 70px rgba(23, 32, 51, 0.14);
}

.photo-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-card.main {
  right: 0;
  top: 0;
  width: 76%;
  height: 520px;
  border-radius: 42px;
  transform: rotate(2deg);
}

.photo-card.small {
  width: 220px;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 30px;
}

.photo-card.small img {
  object-fit: contain;
  mix-blend-mode: multiply;
}

.photo-card.small.one {
  left: 0;
  top: 82px;
  transform: rotate(-7deg);
}

.photo-card.small.two {
  left: 80px;
  bottom: 20px;
  transform: rotate(6deg);
}

.stamp-card {
  position: absolute;
  right: 44px;
  bottom: 8px;
  display: grid;
  place-items: center;
  width: 168px;
  height: 168px;
  border-radius: 50%;
  color: #fff;
  background: #172033;
  box-shadow: 0 24px 60px rgba(23, 32, 51, 0.22);
  text-align: center;
  transform: rotate(-8deg);
}

.stamp-card strong {
  font-size: 42px;
  line-height: 1;
}

.stamp-card span {
  max-width: 110px;
  margin-top: -32px;
  font-size: 12px;
  font-weight: 850;
  color: rgba(255, 255, 255, 0.76);
}

/* FAIXA CORRIGIDA */
.image-marquee {
  overflow: hidden;
  padding: 18px 0;
  background: #172033;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.marquee-track {
  display: flex;
  align-items: center;
  width: max-content;
  gap: 14px;
  padding-left: 14px;
  animation: marqueeMove 42s linear infinite;
}

.marquee-track:hover {
  animation-play-state: paused;
}

.marquee-item {
  width: 176px;
  height: 104px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(23, 32, 51, 0.06);
}

.marquee-item img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  mix-blend-mode: multiply;
}

@keyframes marqueeMove {
  from { transform: translateX(0); }
  to { transform: translateX(-33.333%); }
}

.section {
  padding: 96px 0;
}

.section-title {
  max-width: 760px;
  margin-bottom: 44px;
}

.section-title.split {
  max-width: 100%;
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 30px;
}

.section-title.center {
  margin-inline: auto;
  text-align: center;
}

.section-title h2,
.contact-layout h2 {
  margin-top: 14px;
  color: #172033;
  font-size: clamp(34px, 4.2vw, 58px);
  line-height: 1.02;
  font-weight: 980;
  letter-spacing: -0.055em;
}

.section-title p {
  max-width: 470px;
  color: #667085;
  font-size: 17px;
  line-height: 1.65;
}

.services-section {
  background: #fff;
}

.service-board {
  display: grid;
  grid-template-columns: 0.92fr 1.08fr;
  gap: 22px;
}

.service-feature {
  min-height: 560px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  padding: 36px;
  border-radius: 42px;
  background: linear-gradient(160deg, #fff1f2, #ffffff 58%, #f0fdf4);
  border: 1px solid rgba(23, 32, 51, 0.08);
  box-shadow: 0 22px 70px rgba(23, 32, 51, 0.08);
}

.service-feature img {
  width: 100%;
  max-height: 350px;
  object-fit: contain;
  mix-blend-mode: multiply;
}

.service-feature span,
.highlight-copy span {
  color: #e11d48;
  font-size: 12px;
  font-weight: 950;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.service-feature h3,
.highlight-copy h3,
.media-copy h2,
.faq-card-title h2 {
  margin-top: 12px;
  color: #172033;
  font-size: clamp(28px, 3.2vw, 44px);
  line-height: 1.04;
  font-weight: 980;
  letter-spacing: -0.045em;
}

.steps-list {
  display: grid;
  gap: 14px;
}

.step-line {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 18px;
  padding: 24px;
  border-radius: 30px;
  background: #fbfaf7;
  border: 1px solid rgba(23, 32, 51, 0.08);
  transition: 0.24s ease;
}

.step-line:hover {
  transform: translateX(8px);
  background: #fff;
  box-shadow: 0 18px 48px rgba(23, 32, 51, 0.08);
}

.step-index {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #172033;
  font-weight: 950;
}

.step-line h3 {
  margin-top: 10px;
  color: #172033;
  font-size: 19px;
  font-weight: 950;
}

.step-line p,
.highlight-copy p,
.media-copy p,
.faq-card-title p {
  margin-top: 7px;
  color: #667085;
  line-height: 1.6;
}

/* GALERIA CORRIGIDA */
.catalog-section {
  background: #fbfaf7;
}

.catalog-highlight {
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 24px;
  align-items: center;
  margin-bottom: 28px;
  padding: clamp(24px, 4vw, 38px);
  border-radius: 38px;
  background: #ffffff;
  border: 1px solid rgba(23, 32, 51, 0.08);
  box-shadow: 0 22px 70px rgba(23, 32, 51, 0.07);
}

.highlight-copy h3 {
  max-width: 520px;
}

.highlight-gallery {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.highlight-card {
  height: 188px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  overflow: hidden;
  border-radius: 26px;
  background: linear-gradient(180deg, #ffffff, #f3f4f0);
  border: 1px solid rgba(23, 32, 51, 0.07);
}

.highlight-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  mix-blend-mode: multiply;
}

.catalog-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
  align-items: stretch;
}

.product-card {
  min-width: 0;
  overflow: hidden;
  border-radius: 30px;
  background: #ffffff;
  border: 1px solid rgba(23, 32, 51, 0.08);
  box-shadow: 0 16px 46px rgba(23, 32, 51, 0.06);
  transition: transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease;
}

.product-card:hover {
  transform: translateY(-6px);
  border-color: rgba(225, 29, 72, 0.18);
  box-shadow: 0 24px 66px rgba(23, 32, 51, 0.12);
}

.product-image {
  height: 230px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px;
  background: linear-gradient(180deg, #f9faf7, #f0f1ed);
}

.product-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  mix-blend-mode: multiply;
}

.product-info {
  min-height: 116px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 20px 22px;
}

.product-info h3 {
  color: #172033;
  font-size: 18px;
  font-weight: 950;
}

.product-info p {
  margin-top: 6px;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
}

.media-section {
  background: #fff;
}

.media-grid {
  display: grid;
  grid-template-columns: 0.78fr 1.22fr;
  gap: 46px;
  align-items: start;
}

.media-copy {
  position: sticky;
  top: 120px;
}

.media-copy h2 {
  margin-top: 16px;
}

.benefit-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 28px;
}

.benefit-pills span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 14px;
  border-radius: 999px;
  background: #fbfaf7;
  border: 1px solid rgba(23, 32, 51, 0.08);
  color: #344054;
  font-size: 13px;
  font-weight: 850;
}

.video-mosaic {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.video-box {
  overflow: hidden;
  padding: 10px;
  border-radius: 34px;
  background: #fbfaf7;
  border: 1px solid rgba(23, 32, 51, 0.08);
  box-shadow: 0 18px 54px rgba(23, 32, 51, 0.08);
}

.video-box:nth-child(2),
.video-box:nth-child(3) {
  transform: translateY(36px);
}

.video-box:nth-child(3) {
  transform: translateY(20px);
}

.video-box:nth-child(4) {
  transform: translateY(46px);
}

.video-box video {
  width: 100%;
  height: 330px;
  display: block;
  object-fit: cover;
  border-radius: 25px;
  background: #172033;
}

.faq-section {
  background: #fbfaf7;
}

.faq-grid {
  display: grid;
  grid-template-columns: 0.82fr 1.18fr;
  gap: 54px;
  align-items: start;
}

.custom-faq :deep(.v-expansion-panel) {
  overflow: hidden;
  margin-bottom: 12px;
  border-radius: 26px !important;
  background: #fff !important;
  border: 1px solid rgba(23, 32, 51, 0.08);
  box-shadow: 0 15px 44px rgba(23, 32, 51, 0.05);
}

.custom-faq :deep(.v-expansion-panel-title) {
  padding: 21px 24px;
  color: #172033;
  font-weight: 950;
}

.custom-faq :deep(.v-expansion-panel-text__wrapper) {
  color: #667085;
  line-height: 1.65;
}

.contact-band {
  padding: 78px 0;
  color: #fff;
  background: #172033;
}

.contact-layout {
  display: grid;
  grid-template-columns: 0.95fr 1.05fr;
  align-items: center;
  gap: 40px;
}

.contact-layout h2 {
  color: #fff;
}

.contact-box {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  padding: 12px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.input-message :deep(.v-field) {
  border-radius: 999px;
  box-shadow: none;
}

.light-btn {
  color: #172033 !important;
  background: #fff !important;
}

.footer {
  padding: 24px 0;
  background: #fff;
}

.footer-inner {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  color: #667085;
  font-size: 14px;
}

@media (max-width: 1040px) {
  .nav-links,
  .nav-cta {
    display: none;
  }

  .menu-toggle,
  .mobile-panel {
    display: block;
  }

  .topbar {
    border-radius: 28px;
  }

  .hero-layout,
  .service-board,
  .catalog-highlight,
  .media-grid,
  .faq-grid,
  .contact-layout {
    grid-template-columns: 1fr;
  }

  .photo-stack {
    min-height: 560px;
  }

  .section-title.split {
    display: block;
  }

  .section-title.split p {
    margin-top: 16px;
  }

  .catalog-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .media-copy {
    position: static;
  }
}

@media (max-width: 720px) {
  .topbar {
    top: 10px;
    width: calc(100% - 20px);
  }

  .topbar-inner {
    min-height: 66px;
    padding: 0 14px 0 18px;
  }

  .logo-box {
    width: 108px;
  }

  .hero {
    min-height: auto;
    padding: 110px 0 64px;
  }

  .hero-buttons,
  .hero-buttons .v-btn,
  .hero-buttons button {
    width: 100%;
  }

  .photo-stack {
    min-height: 430px;
  }

  .photo-card.main {
    width: 100%;
    height: 330px;
    transform: none;
  }

  .photo-card.small {
    width: 150px;
    height: 118px;
  }

  .photo-card.small.one {
    left: 8px;
    top: 250px;
  }

  .photo-card.small.two {
    left: auto;
    right: 6px;
    bottom: 0;
  }

  .stamp-card {
    display: none;
  }

  .image-marquee {
    padding: 12px 0;
  }

  .marquee-track {
    gap: 10px;
    padding-left: 10px;
    animation-duration: 34s;
  }

  .marquee-item {
    width: 138px;
    height: 86px;
    padding: 10px;
    border-radius: 18px;
  }

  .section {
    padding: 70px 0;
  }

  .service-feature {
    min-height: auto;
    padding: 26px;
    border-radius: 32px;
  }

  .step-line {
    grid-template-columns: 1fr;
  }

  .highlight-gallery,
  .catalog-grid,
  .video-mosaic {
    grid-template-columns: 1fr;
  }

  .highlight-card {
    height: 168px;
  }

  .product-image {
    height: 215px;
  }

  .product-info {
    min-height: auto;
  }

  .video-box:nth-child(2),
  .video-box:nth-child(3) {
    transform: none;
  }

  .video-box video {
    height: 260px;
  }

  .contact-box {
    grid-template-columns: 1fr;
    border-radius: 24px;
  }

  .contact-box .v-btn,
  .contact-box button {
    width: 100%;
  }

  .footer-inner {
    flex-direction: column;
    text-align: center;
  }

  .float-actions {
    right: 16px;
    bottom: 16px;
  }
}
</style>